export default "__VITE_ASSET__2493c7e4__"